const positionStyles = {
  left: {
    drawer: 'top-0 left-0 h-full w-[80%]',
    transform: {
      open: 'translate-x-0',
      closed: '-translate-x-full',
    },
  },
  bottom: {
    drawer: 'bottom-0 left-0 w-full h-64',
    transform: {
      open: 'translate-y-0',
      closed: 'translate-y-full',
    },
  },
  right: {
    drawer: 'top-0 right-0 h-full w-[80%]',
    transform: {
      open: 'translate-x-0',
      closed: 'translate-x-full',
    },
  },
};

const DrawerModal = ({
  onClose,
  children,
  isOpen,
  bgColor = '#fff',
  position = 'left',
}) => {
  const styles = positionStyles[position];

  return (
    <>
      {/* Overlay */}
      <div
        className={`bg-opacity-50 fixed inset-0 z-5000 bg-black/50 transition-opacity duration-300 ${isOpen ? 'visible opacity-100' : 'pointer-events-none invisible opacity-0'}`}
        onClick={onClose}
      />

      {/* Drawer */}
      <div
        style={{ backgroundColor: bgColor }}
        className={`gray-scroll fixed z-5001 transform overflow-y-auto transition-all duration-300 ease-in-out ${
          styles.drawer
        } ${isOpen ? `${styles.transform.open} visible opacity-100` : `${styles.transform.closed} pointer-events-none invisible opacity-0`}`}
      >
        {children}
      </div>
    </>
  );
};

export default DrawerModal;
